
import { Component, Prop, Vue } from 'vue-property-decorator'
import { wxpayDetail, wxpaySubmit, wxpayReject, wxpayLogs, wxpayStatus } from '@/api/wxpay'
import {SubjectIDIdDocType} from '@/utils/type'
@Component({})
export default class WxpayDetail extends Vue{
  loading = false
  detail: any = {}
  logs = []
  statusInfo = {}
  form:any = {
    payId: '',
    shopId: 0,
    status: 1,
    reason: ''
  }
  submitLoading = false
  
  getDetail() {
    this.loading = true
    wxpayDetail({shopId: this.$route.query.id}).then(res => {
      this.loading = false
      this.detail = res
      this.detail.subjectIDIdDocTypeDesc = SubjectIDIdDocType[this.detail.subjectIDIdDocType]
      this.detail.subjectUboIdTypeDesc = SubjectIDIdDocType[this.detail.subjectUboIdType]
      this.detail.contactIdDocTypeDesc = SubjectIDIdDocType[this.detail.contactIdDocType]
      this.getLogs()
    })
  }
  getStatus() {
    wxpayStatus({shopId: this.$route.query.id}).then(res => {
      this.statusInfo = res
    })
  }
  getLogs() {
    wxpayLogs({payId: this.detail.id}).then(res => {
      this.logs = res
    })
  }
  submit() {
    if(this.form.status == 2 && this.form.reason.trim() == '') {
      this.$message.error('请填写驳回理由')
      return
    }
    this.form.payId = this.detail.id;
    this.form.shopId =this.$route.query.id
    this.$confirm('确认提交审核吗?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      this.submitLoading = true
      if (this.form.status == 1) {
        wxpaySubmit(this.form).then(res => {
          this.$message.success('审核成功')
          this.submitLoading = false
          this.getLogs()
          this.getStatus()
        }).catch((err:any) => {
          this.submitLoading = false
        })
      } else {
        wxpayReject(this.form).then(res => {
          this.$message.success('驳回申请单成功')
          this.submitLoading = false
          this.getLogs()
          this.getStatus()
        }).catch((err:any) => {
          this.submitLoading = false
        })
      }
    }).catch(() => {});
  }
  created() {
    this.getDetail()
    this.getStatus()
  }
}
